import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=5280066f&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=5280066f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280066f",
  null
  
)

export default component.exports